import React from "react";
import BaseText from './Base/Base'
import Construction from '../../../pages/New/components/Construction'
import {employmentInsertMessage,getRecruitment} from '../../../utils/api/index'

class TextEditing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            constructionVisible:props.constructionVisible,
            userLoginInfo:props.userLoginInfo,
            handleConstructionVisible:props.handleConstructionVisible,
            getPages:props.getPages,
            isChange:props.isChange
        }
    }
    render() {
        const {constructionVisible,handleConstructionVisible,getPages,isChange} = this.state
        return (
            <div>
                {constructionVisible?<BaseText isChange={isChange} getPages={getPages} userLoginInfo={this.props.userLoginInfo} constructionVisible={constructionVisible} handleConstructionVisible={handleConstructionVisible} />:null}
            </div>
        )
    }
}
TextEditing.defaultProps={}


export default TextEditing
